var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("optima.category")) + " Optima")]),
      _c("optima-menu"),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("ajax-single-file", {
                attrs: {
                  model: _vm.fileId,
                  label: _vm.$t("optima.importCategoryFromXls"),
                  accept: "application/xls",
                  items: _vm.items
                },
                on: {
                  "update:model": function($event) {
                    _vm.fileId = $event
                  },
                  "update:items": function($event) {
                    _vm.items = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "mt-3" },
            [
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.load } },
                [_vm._v(_vm._s(_vm.$t("global.load")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.categories,
          "footer-props": {
            "items-per-page-options": [
              { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
            ]
          },
          "hide-default-footer": ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(" " + _vm._s(props.item.code) + " ")
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(" " + _vm._s(props.item.description) + " ")
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }